import { render, staticRenderFns } from "./StateDashboard.vue?vue&type=template&id=2c7a80bd&scoped=true&"
import script from "./StateDashboard.vue?vue&type=script&lang=js&"
export * from "./StateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StateDashboard.vue?vue&type=style&index=0&id=2c7a80bd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a80bd",
  null
  
)

export default component.exports